const styles = theme => ({
  list: {
    width: '100%'
  },
  listItem: {
    width: '100%',
    minWidth: '240px',
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    textAlign: 'left',
    paddingTop: '11px',
    paddingBottom: '11px',
    justifyContent: 'flex-start',
    textDecoration: 'none',
    '&$selected, &$selected:hover, &$selected:focus': {
      backgroundColor: '#E67743'
    }
  },
  listItemText: {
    fontSize: '14px',
    fontFamily: 'Gilroy-Light',
    fontWeight: 'bolder'
  },
  collapse: {
    backgroundColor: '#E67743',
    paddingTop: 4,
    paddingBottom: 4
  },
  collapseItemText: {
    fontSize: '12px',
    fontFamily: 'Gilroy-Light',
    paddingLeft: '0px',
    textAlign: 'left'

  },
  subListItem: {
    backgroundColor: '#E67743 !important',
    width: '100%',
    padding: 'auto',
    boxSizing: 'border-box',
    color: '#000',
    '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus': {
      backgroundColor: '#cc6633 !important', // seçili hali
      color: '#fff'
    },
    '&:hover': {
      backgroundColor: '#E67743'
    }
  },
  selectedListItem: {
  backgroundColor: '#cc6633 !important',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#cc6633'
  }
},
selectedSubItem: {
  backgroundColor: '#cc6633 !important',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#cc6633'
  }
},
  selected: {}
});

export default styles;

